export default {
  dbh_home: '首页',
  dbh_dashboard: '经分',
  dbh_datalab: '自助分析',
  dbh_ai: 'AI',
  dbh_intelligence: '情报',
  dbh_opinion: '舆情',
  dbh_marketing: '市场专区',
  dbh_databrain: '数据大脑',
  dbh_gpop: '管理看板',
  dbh_mgmt: 'Mgmt',
  dbh_studio_hub: 'Studio专区',
  dbh_benchmark: '行业基准',
  dbh_user_center: '用户中心',
  dbh_explore: '探索',
  dbh_following: '收藏',
  dbh_iegglobal: 'IEG Global 游戏列表',
  dbh_getgameaccess: '权限申请',
  dbh_bigriser: '新入榜/霸榜',
  dbh_mentions: '声量',
  dbh_sentiment: '情感分',
  dbh_score: '商店评分',
  dbh_top_free: '下载榜',
  dbh_top_paid: '付费榜',
  dbh_store_topSeller: '商店畅销榜',
  dbh_keywords: '关键词',
  dbh_news: '资讯',
  dbh_more: '更多',
  dbh_learnmore: '更多',
  dbh_competitor: '竞品',
  dbh_publisher: '发行商',
  dbh_downloads: '下载量',
  dbh_upcoming: '即将上线',

  dbh_all: '所有游戏',
  dbh_mobile: '手游',
  dbh_pc: '端游',
  dbh_console: '主机',
  dbh_pcconsole: '电脑 & 主机游戏',
  dbh_company: '公司',
  dbh_table_disablegame_tip: `图表最多显示10款游戏数据，请先取消现有游戏选择，再新增`,

  dbh_bigriser_games: '新入榜/霸榜',
  dbh_noteworthy_games: '重点关注',
  dbh_newrelease_mobile_games: '七天新游',
  dbh_newrelease_pc_games: '七天新游',
  dbh_newrelease_console_games: '七天新游',
  dbh_upcoming_mobile_games: '即将上线',
  dbh_upcoming_pc_games: '即将上线',
  dbh_upcoming_console_games: '即将上线',
  dbh_game_firstly_breaking: '首次进入榜单的游戏',

  dbh_spotlight_noteworthy_games: '重点关注',
  dbh_spotlight_newrelease_mobile_games: '30天新游',
  dbh_spotlight_newrelease_pc_games: '30天新游',
  dbh_spotlight_newrelease_console_games: '30天新游',
  dbh_spotlight_upcoming_mobile_games: '180天即将上线',
  dbh_spotlight_upcoming_pc_games: '180天即将上线',
  dbh_spotlight_upcoming_console_games: '180天即将上线',
  dbh_spotlight_big_risers: '7日活跃突增',

  dbh_spotlight_no_data: '暂无数据',
  dbh_spotlight_newrelease_mobile_nodata: '无新手游进入App Store免费榜前10',
  dbh_spotlight_trailer_views: '预告观看量',
  dbh_spotlight_pre_registration_top5: '预注册#1-5',
  dbh_spotlight_upcoming_mobile_nodata: '暂无即将上线手游的IGN预告片数据',
  dbh_spotlight_tip_pre_registration_ranking_data_of:
    '{chartSource}榜单数据来源于{googlePlaySource}，',
  dbh_spotlight_tip_pre_registration_count_countries:
    '统计当天进入预注册榜前5的国家数量。',
  dbh_spotlight_bigriser_mobile_nodata: '无游戏活跃用户增长显著（>18%）',
  dbh_spotlight_units: '销量',
  dbh_spotlight_wishlist: '愿望单榜',
  dbh_spotlight_newrelease_top10: '新游榜前10',
  dbh_spotlight_comingsoon_top10: '即将上线榜前10',
  dbh_spotlight_newrelease_console_nodata: '无新发售主机游戏进入PlayStation新游榜前10',
  dbh_spotlight_upcoming_console_nodata: '无即将发售主机游戏进入PlayStation即将上线榜前10',
  dbh_spotlight_bigriser_nodata: '无游戏活跃用户增长显著（>18%）',

  dbh_announcements: '公告',
  dbh_global_holidays: '全球节假日',
  dbh_recentlyviewed: '最近浏览',
  dbh_recently_dashboard: '经分',
  dbh_recently_intelligence: '情报',
  dbh_recently_opinions: '舆情',
  // dbh_recentlyviewed_tip: 'Data is yet to be ready',
  dbh_datasources: '数据来源',
  dbh_datasmap: '数据地图',
  dbh_datasmap_games: '游戏总量',
  dbh_datasmap_companies: '公司总量',
  dbh_mobiledataBrain_title: '数据大脑移动版',
  dbh_mobiledataBrain_desc: '微信小程序扫码登录',

  dbh_storerank_topnewfree: '免费新游榜',
  dbh_storerank_topfree: '免费榜',
  dbh_storerank_topgrossing: '畅销榜',
  dbh_storerank_topnewpaid: '付费新游榜',
  dbh_storerank_toppaid: '付费榜',
  dbh_storerank_toppopular: '热门新品榜',
  dbh_storerank_topsellers: '畅销榜',
  dbh_storerank_newandtrending: '热门新品榜',
  dbh_storerank_topwishlists: '最热愿望单',
  dbh_storerank_newrelease: '上新榜',
  dbh_storerank_upcoming: '即将推出',
  dbh_storerank_mostplayed: '最常玩游戏',
  dbh_storerank_bestselling: '最畅销游戏',
  dbh_storerank_mostdownloaded: '最多下载',
  dbh_storerank_newgames: '新游榜',
  dbh_storerank_comingsoon: '即将推出',
  dbh_storerank_indiesgames: '独立游戏榜',
  dbh_storerank_freetoplay: '免费榜',
  dbh_storerank_bestsellers: '畅销榜',

  dbh_lasted7d: '霸榜7天',

  dbh_metric_dau: '日活跃',
  dbh_metric_avg_dau: '7日均活跃',
  dbh_metric_sum_iap_rev: '累计IAP收入',
  dbh_metric_avg_pcu: '7日均PCU',
  dbh_metric_sum_units: '累计销量',
  dbh_metric_sum_revenue_console: '累计收入',
  dbh_spotlight_tip_bigriser_dau: '7日突增：平均日活跃用户数，周环比增长超过 18% 的游戏，按活跃增长量排名。',
  dbh_spotlight_tip_bigriser_pcu: '7日突增：平均日最高在线用户数，周环比增长超过 18% 的游戏，按活跃增长量排名。',
  dbh_spotlight_tip_bigriser_console_dau: '7日突增：平均日活跃用户数，周环比增长超过 18% 的游戏，按活跃增长量排名。',
  dbh_metric_mau: '月活跃',
  dbh_metric_revenue: '付费金额($)',
  dbh_metric_revenue_s: '收入($)',
  dbh_metric_newusers: '新进用户',
  dbh_metric_d2: '次留',
  dbh_metric_arpu: '活跃ARPU($)',
  dbh_metric_arppu: '付费ARPU($)',
  dbh_metric_payer_growth: '付费渗透率',
  dbh_metric_payer: '付费人数',
  dbh_metric_pcu: '最高同时在线',
  dbh_metric_aotmin: '平均在线时长(分钟)',
  dbh_metric_tru: '总注册用户数',
  dbh_metric_region: '发行区域',
  dbh_metric_phase: '阶段',
  dbh_metric_game: '游戏名称',
  dbh_metric_p_heat: '潜力指数',
  dbh_metric_pheat: '潜力指数',
  dbh_metric_topcharts: '榜单',
  dbh_metric_freetop10: '免费榜前10',
  dbh_metric_release: '上线时间',
  // dbh_metric_newandtrending: '新游和热门游戏',
  dbh_metric_newandtrending: '热门新品榜',
  dbh_metric_rank: '排名',
  dbh_metric_free: '免费下载',
  dbh_metric_steamwishlist: 'Steam愿望单',
  dbh_metric_gamalytic_steam_daily_wishlist: 'Gamalytic Steam每天新增愿望单人数',
  dbh_metric_gamalytic_steam_lifetime_wishlist: 'Gamalytic Steam总愿望单人数',
  dbh_metric_hourswatched: '直播观看时长',
  dbh_metric_peakccv: '峰值观众人数',
  dbh_metric_steamtopsellers: 'Steam热卖榜',
  dbh_metric_steamtopsellers_combine: '热卖榜',
  dbh_metric_digitalarppu_usonly: '数字版付费ARPPU',
  // dbh_metric_digitalarppu_usonly: '数字版游戏平均付费玩家收入(仅美国)',
  dbh_metric_digital_revenue: '数字版收入',
  dbh_metric_units_combine: '本体拷贝销售数',
  dbh_metric_gsd_combine: '欧洲本体拷贝销售数',
  dbh_metric_lifetime_player: '生命周期玩家数',

  dbh_metric_revenue_dol: '付费金额($)',
  dbh_metric_New: '新进用户',
  dbh_metric_d2_t1: '次留(T-1)',
  dbh_metric_arpu_dol: '活跃ARPU($)',
  dbh_metric_payer_pre: '付费渗透率',

  dbh_metric_calibrated_data: '数据大脑校准数据',
  dbh_metric_dataof_comesfrom: '{sourceName}数据来源于 ',
  dbh_metric_dataof_comes: '数据来源于 ',
  dbh_metric_rankingdata_of: 'icon {sourceName}榜单数据来源于',
  dbh_metric_dataBrain_calibrated_details: '数据大脑校准数据。点击游戏名称查看更多',
  dbh_metric_databrain_text_desc: `DataBrain校准数据主要来自算法模型预测，输入考虑的因素有渠道打听的竞品真实数据、内部部分分国家真实数据、商店排名、Annie Sensor tower数据趋势等等。有任何竞品表现数据反馈欢迎随时联系ivyyfchen。`,

  // spotlight 悬浮窗文案
  dbh_spotlight_tip_avg: '取所选时间段内的平均值。',
  dbh_spotlight_tip_sum: '取所选时间段内的总值。',
  dbh_spotlight_tip_sum_units: '取所选时间段内的累计值。',
  dbh_spotlight_tip_revenue_commission: '收入已从应用内购买、订阅和付费应用下载中移除30%的佣金。',
  dbh_spotlight_tip_sum_revenue_commission: '收入已从应用内购买、订阅和付费应用下载中移除30%的佣金。',
  dbh_spotlight_tip_mobile_range: '仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据。',
  dbh_spotlight_tip_ranking_data_of: '{source}榜单数据来源于 ',
  dbh_spotlight_tip_count_countries: '统计当天进入{chart}的国家数量。',
  dbh_spotlight_tip_free_ranking_data_of: '{freeSource}榜单数据来源于 {appStoreSource}.',
  dbh_spotlight_tip_free_count_countries: '统计当天进入免费榜前10的国家数量。',
  dbh_spotlight_tip_newrelease_ranking_data_of: '{newGamesSource}榜单数据来源于 {playStationSource}.',
  dbh_spotlight_tip_newrelease_count_countries: '统计当天进入新游榜前10的国家数量。',
  dbh_spotlight_tip_comingsoon_ranking_data_of: '{comingSoonSource}榜单数据来源于 {playStationSource}.',
  dbh_spotlight_tip_comingsoon_count_countries: '统计当天进入即将上线榜前10的国家数量。',
  dbh_spotlight_tip_play_station: 'Play Station',
  dbh_spotlight_tip_ign_trailer: '总观看量源自{ign}IGN YouTube官方频道，由{databrain}DataBrain追踪的"即将上线手游"预告片播放总量。',
  dbh_spotlight_tip_console_dau_def: '指标含义：日活跃用户',
  dbh_spotlight_tip_console_dau_granularity: '时间粒度：日',
  dbh_spotlight_tip_console_dau_update: '更新时间：每周四',
  dbh_spotlight_tip_console_dau_agg: '时间段计算方式：每日取平均值',
  dbh_spotlight_tip_console_dau_source: '数据来源：',
  dbh_spotlight_tip_digital_revenue: '收入($)',
  dbh_spotlight_tip_steam_wishlist: '{wishlistSource}榜单数据来源于 {steamSource}',

  // 首页搜索
  dbh_search_placeholder: '搜索任何游戏或公司',
  dbh_autocomplete_data_lover: 'DataBrain\n数据达人荣誉榜',
  dbh_autocomplete_yearly_poster: 'DataBrain 2025\n年度荣誉榜单',
  dbh_autocomplete_tip: '没有匹配的标签',
  dbh_back: '返回',
  dbh_recent_search: '最近搜索',
  dbh_search_table_total: '共{total}项',
  dbh_clear_all: '清空',
  dbh_search_trending: '热门游戏',
  dbh_result_useful: '结果有用吗？',
  dbh_search_pos: '正面',
  dbh_search_neg: '负面',
  dbh_operation_failed_network: '操作失败，请检查您的网络',
  dbh_unfollow_successful: '取消收藏成功',
  dbh_unfollow: '取消收藏',
  dbh_follow: '收藏',
  dbh_feedback_isgod_tips: '感谢您的反馈!',
  dbh_searching: '查询中...',
  dbh_searching_company_preview: '公司信息预览规划中，',
  dbh_searching_thanks_patience: '敬请期待!',
  dbh_recent: '历史',
  dbh_search: '搜索',

  dbh_versionhistory_helptitle: '版本更新信息',
  dbh_versionhistory_history: '版本历史',
  dbh_versionhistory_detail: '版本详情',
  dbh_versionhistory_history_tip:
    '我们会向活跃的DataBrain用户发送产品更新月报，发件地址为{email}，如果您在收件箱中找不到邮件，{br}请检查垃圾箱。',

  dbh_search_dashboard_tip_woa: `请到敏感权限系统申请经分权限: https://appauth.woa.com`,
  dbh_search_dashboard_tip_intlgame: `请到敏感权限系统申请经分权限: https://appauth.intlgame.com`,
  dbh_search_dashboard_tip_sensitive:
    "<div style='max-width: 300px;'>经分业务敏感权限，请联系 Pteam 或 ivyyfchen ivyyfchen@global.tencent.com 开通权限。</div>",
  dbh_search_intelligent_tip: `情报游戏权限申请请联系velvetjiang`,
  dbh_search_opinion_tip: `目前你无法访问该游戏的数据，请联系Sophiaxwxu获取权限`,
  dbh_search_g_pop_tip: `如需申请GPOP访问权限，敬请联系陈景莉<br/>(jinglichen@tencent.com)。`,
  dbh_search_opinion_nodata: `暂未接入舆情配置，有相关需求联系sophiaxwxu`,

  dbh_search_dashboard_tip_t_1:
    '前一天次留，次留=XX注册日期第2天存留用户数/XX注册日期新注册用户数，注册日期是第一天。<br/>超过一天展示平均次留，统计周期内每一天注册用户次留用户数求和/统计周期内每一天新注册用户数求和。',
  dbh_search_dashboard_tip_global: `Dashboard游戏权限申请：<br/>腾讯用户：请联系Studio的Pteam对接人<br/>Studio用户：请联系Studio内DataBrain对接人<br/>其他任何疑问请联系sallyxue@tencent.com`,

  dbh_ai_recognize_tips: 'AI正在识别并协助填写所需信息…',
  dbh_ai_recognize_estimated_time_text: '预计处理时间为{range}分钟',
  dbh_report_uploader_footer_linker_text: '查看历史报告列表',
};
